import type { IUseCase } from 'shared-kernel';
import type { ISecurityRepository } from '../../../domain/ports';
import type { ResetPasswordData } from '../../dto/dtos';

export class ResetPasswordUseCase implements IUseCase<ResetPasswordData, void> {
  constructor(
    private readonly securityRepository: ISecurityRepository,
  ) {}

  async execute(input: ResetPasswordData): Promise<void> {
    const response = await this.securityRepository.resetPassword(input);

    if (!response.succes) {
      throw new Error(response.message || 'Echec du reset du mot de passe');
    }
  }
}
